import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../Api/api';

const LoginForm = () => {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await api.post('/auth/login', { name, password });
            const data = response.data; //parse Json auto
            const user = data.user;
            const token = data.token;
            // save full user object and token
            localStorage.setItem('currentUser', JSON.stringify(user));
            console.log('Logged-in user:', user); //show user object in console
            localStorage.setItem('token', token); 

            alert('Login successful');
            navigate('/dashboard');

        } catch (error) {
            console.error('Login error:', error);
            setError('Invalid credentials');
        }
    };


    return (
        <div className="container mt-5 d-flex justify-content-center">
            <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>
                <h2 className="mb-4 text-center">Login</h2>
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">Name:</label>
                        <input type="text"
                            placeholder="Enter your name"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Password:</label>
                        <input
                            type="password"
                            placeholder="Enter you password"
                            className="form-control"
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="d-flex justify-content-center">
                        <button type="submit" className="btn btn-primary login-button">
                            Login
                        </button>
                    </div>                   
                </form>
            </div>
        </div>
    );
};

export default LoginForm;